import { IMAGE_EXTENSIONS, FIXED_SIZE_FORMATS, MAX_IMAGE_SIZE_MB } from "@/helpers/constants";
import NotificationsMixin from "./NotificationsMixin";

export default {
  mixins: [NotificationsMixin],
  data() {
    return {
      noImageUrl: "/static/default/img/no_image.jpg",
      imageData: {
        data: null,
        config: {
          header: {
            "Content-Type": "image/png"
          }
        }
      }
    };
  },
  methods: {
    uploadImage(event, extensions) {
      let [fileType, fileExt] = event.target.files[0].type.split("/");
      let fileName = event.target.files[0].name;

      const imageSizeMB = (event.target.files[0].size / (1024 * 1024)).toFixed(2);
      let isAvailableImageFormat;

      if (extensions) {
        isAvailableImageFormat = extensions.includes(fileExt);
      } else {
        isAvailableImageFormat = IMAGE_EXTENSIONS.includes(fileExt) || FIXED_SIZE_FORMATS.includes(fileExt);
      }

      if (imageSizeMB >= MAX_IMAGE_SIZE_MB) {
        this.showNotification({ type: "error", message: `${fileName} is too large, maximum file size is 40MB` });
        event.target.value = "";
        return;
      }

      if (isAvailableImageFormat) {
        let data = new FormData();
        data.append("file", event.target.files[0]);
        data.append("resize_image_profile", "user_public_profile");

        this.imageData.data = data;
        this.imageData.config.header["Content-Type"] = event.target.files[0].type;
        return window.URL.createObjectURL(event.target.files[0]);
      } else if (fileType !== "image") {
        this.showNotification({
          type: "error",
          message: "Upload only an image please"
        });
      } else if (fileType === "image" && !isAvailableImageFormat) {
        this.showNotification({
          type: "error",
          message: `${fileName} has an invalid extension. Valid extension(s): ${
            extensions ? extensions.toString() : IMAGE_EXTENSIONS.toString()
          }`
        });
      }
    }
  }
};
